<template>
  <vs-prompt
    :title="titleText"
    @accept="acceptAddNewEventsPrompt"
    @close="closeAddNewEventsPrompt"
    @cancel="closeAddNewEventsPrompt"
    :active.sync="addNewEventPrompt"
    :accept-text="titleText"
    :is-valid="validForm"
  >
    <div>
      <!-- <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Type</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full mb-5">
          <div class="horizontal-row">
            <vs-button
              v-for="type in types"
              :key="type.id"
              @click="event_type = type.id"
              :color="event_type == type.id ? 'success' : 'rgb(80, 80, 80)'"
              :type="event_type == type.id ? 'filled' : 'border'"
              icon-pack="feather"
              :icon="event_type == type.id ? 'icon-check' : ''"
              class="mr-3 selection-button"
              >{{ type.label }}</vs-button
            >
          </div>
        </div>
      </div> -->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Title</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-input
            class="inputx w-full"
            placeholder="Title"
            v-model="event_title"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Content text</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full">
          <vs-textarea
            v-model="event_description"
            placeholder="Content text"
            class="w-full"
            height="150px"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Start & end date</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <flat-pickr
            :config="datePickerConfigStart"
            v-model="event_startDate"
            placeholder="Start..."
            style="display: flex; width: 100%"
          />
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <flat-pickr
            :config="datePickerConfig"
            v-model="event_endDate"
            placeholder="End..."
            style="display: flex; width: 100%"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Recurring</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-checkbox v-model="isRecurring">Recurring</vs-checkbox>
        </div>
      </div>
      <transition name="fade">
        <div class="vx-row mb-6" v-if="isRecurring">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Days</span>
          </div>
          <div class="vx-col sm:w-4/5 w-full" style="display: flex">
            <vs-checkbox
              v-for="(day, index) in recurringDays"
              :key="index"
              v-model="selectedRecurringDays"
              :vs-value="day.id"
              >{{ day.name }}</vs-checkbox
            >
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="vx-row mb-6" v-if="isRecurring">
          <div class="vx-col sm:w-1/5 w-full"></div>
          <div class="vx-col sm:w-4/5 w-full">
            <span style="color: #ccc">Repeats {{ recurringText }}</span>
          </div>
        </div>
      </transition>

      <!--<div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Responsible</span>
        </div>
        <div class="vx-col">
          <vs-input
            class="inputx w-full"
            placeholder="Full name"
            v-model="event_responsible"
          />
        </div>
      </div>-->

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Responsible</span>
        </div>
        <div class="vx-col sm:w-3/5 w-full">
          <TypeAhead
            v-model="data"
            classes="typeahead-container"
            :placeholder="placeholder"
            src=""
            :getResponse="getResponse"
            :selectFirst="selectFirst"
            :limit="parseInt(limit)"
            :queryParamName="queryParamName"
            :minChars="parseInt(minChars)"
            :delayTime="parseInt(delayTime)"
            :onHit="onHit"
            :highlighting="highlighting"
            :render="render"
            :fetch="fetch"
          ></TypeAhead>

          <div v-if="event_responsible_name !== ''">
            <vs-chip
              v-if="event_responsible_userId !== ''"
              color="success"
              class="mt-6 instructor-chip"
            >
              {{ event_responsible_name }}
            </vs-chip>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Platform and type</span>
        </div>
        <div class="vx-col sm:w-2/5">
          <vs-select label="Platform" v-model="smc_platform">
            <vs-select-item
              :key="index"
              :value="index"
              :text="index"
              v-for="(item, index) in list"
            />
          </vs-select>
        </div>
        <div class="vx-col sm:w-2/5">
          <vs-select label="Type" v-model="smc_type">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in list[smc_platform]"
            />
          </vs-select>
        </div>
      </div>

      <transition name="fade">
        <div class="vx-row mb-6" v-if="event_type == 2">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Estimated cost ({{ this.currencyCode }})</span>
          </div>
          <div class="vx-col">
            <vs-input type="number" class="inputx w-full" v-model="smc_cost" />
          </div>
        </div>
      </transition>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Tags</span>
        </div>
        <div class="vx-col sm:w-4/5">
          <vs-chips placeholder="New Tag" v-model="event_tags">
            <vs-chip
              @click="remove(chip)"
              :key="chip"
              v-for="chip in event_tags"
              closable
            >
              {{ chip }}
            </vs-chip>
          </vs-chips>
        </div>
      </div>

      <div class="buttons-footer-left">
        <vs-button
          v-if="event_id !== ''"
          color="danger"
          @click.native="confirmDelete"
          :type="!isRecurring ? 'border' : 'filled'"
          class=""
          >Delete{{ isRecurring ? "" : "" }}</vs-button
        >

        <vs-button
          v-if="event_id !== '' && isRecurring"
          color="danger"
          @click.native="deleteThisDay"
          type="border"
          class="ml-2"
          >Delete{{ isRecurring ? " this only" : "" }}</vs-button
        >
      </div>
    </div>
  </vs-prompt>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import { mapGetters } from "vuex";
import { RRule, RRuleSet, rrulestr } from "rrule";
import TypeAhead from "vue2-typeahead";

export default {
  components: {
    TypeAhead,
    flatPickr,
  },
  data() {
    const that = this;
    return {
      types: [
        {
          id: 1,
          label: "SMC",
        },
        {
          id: 2,
          label: "Paid Media",
        },
      ],
      // Typeahead
      data: "",
      selectFirst: false,
      limit: 10,
      queryParamName: ":keyword",
      minChars: 2,
      delayTime: 500,
      placeholder: "Please enter responsible name or email",
      classes: "typeahead",

      calendarClickedDate: null,
      exclusionDays: [],
      rruleConfig: {
        freq: RRule.WEEKLY,
        //interval: 5,
        //byweekday: [RRule.MO, RRule.FR],
        //dtstart: new Date(Date.UTC(2012, 1, 1, 10, 30)),
        //until: new Date(Date.UTC(2012, 12, 31)),
      },
      event_rrule: null,
      momentFormat: "DD-MM-YYYY", // "DD-MM-YYYY HH:mm" for time
      smc_platform: "Facebook",
      smc_type: 0,
      smc_cost: 0,
      selectedRecurringDays: [],
      recurringDays: [
        { id: 0, name: "Mon" },
        { id: 1, name: "Tue" },
        { id: 2, name: "Wed" },
        { id: 3, name: "Thu" },
        { id: 4, name: "Fri" },
        { id: 5, name: "Sat" },
        { id: 6, name: "Sun" },
      ],
      list: {
        Facebook: [
          { value: 0, text: "Feed" },
          { value: 1, text: "Story" },
          { value: 2, text: "Event" },
          { value: 2, text: "Competition" },
        ],
        Instagram: [
          { value: 0, text: "Feed" },
          { value: 1, text: "IGTV" },
          { value: 1, text: "Story" },
          { value: 1, text: "Competition" },
        ],
        Youtube: [{ value: 0, text: "Video" }],
        App: [{ value: 0, text: "Message" }],
        SMS: [{ value: 0, text: "Message" }],

        Newsletter: [{ value: 0, text: "Link" }],
        Other: [{ value: 0, text: "Other" }],
      },
      event_id: "",
      event_title: "",
      event_description: "",
      event_startDate: null,
      event_endDate: null,
      event_type: 0,
      isRecurring: false,
      event_responsible_name: "",
      event_responsible_userId: "",
      event_tags: [],
      addNewEventPrompt: false,
      datePickerConfig: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
      },
      datePickerConfigStart: {
        enableTime: false, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "d-m-Y", // "d-m-Y H:i" for time
        defaultHour: 12,
        defaultMinute: 30,
        defaultSecond: 0,
        onChange: function (selectedDates) {
          that.updateEndDate();
        },
      },
      currencyMap: {
        Danmark: "DKK",
        Finland: "EUR",
        Norge: "NOK",
        England: "GBP",
      },
      callback: null,
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      userId: "users/userId",
    }),
    typeString() {
      return this.event_type === 1 ? "social" : "paid media";
    },
    currencyCode() {
      return this.currencyMap[this.activeVenue.country];
    },
    validForm() {
      return (
        this.event_title !== "" &&
        this.event_startDate !== "" &&
        this.event_endDate !== "" &&
        (moment(this.event_endDate, this.momentFormat).isAfter(
          moment(this.event_startDate, this.momentFormat)
        ) ||
          moment(this.event_endDate, this.momentFormat).isSame(
            moment(this.event_startDate, this.momentFormat)
          ))
      );
    },
    titleText() {
      return (this.event_id !== "" ? "Update " : "Add ") + this.typeString;
    },

    recurringText() {
      const rrule = new RRule({
        ...this.rruleConfig,
        byweekday: this.selectedRecurringDays,
        dtstart: moment.utc(this.event_startDate, this.momentFormat).toDate(),
        until: new Date(
          moment.utc(this.event_endDate, this.momentFormat).format()
        ),
      });
      return rrule.toText();
    },
  },
  mounted() {},
  methods: {
    getResponse: function (response) {
      return response.data;
    },
    onHit: function (item, vue /*, index*/) {
      let current = vue.current;
      let selectedItem = vue.data[current];

      this.event_responsible_userId = selectedItem.userId;
      this.event_responsible_name = item;
    },
    highlighting: function (item, vue) {
      return item.toString().replace(vue.query, `<b>${vue.query}</b>`);
    },
    render: function (items /*, vue*/) {
      const titles = items.map(
        (x) => x.firstName + " " + x.lastName + " (" + x.email + ")"
      );
      return titles;
    },
    fetch: function (/*url*/) {
      return this.$http.get(
        process.env.VUE_APP_API_BASE_URL + "/users?query=" + this.data
      );
    },

    updateEndDate() {
      this.event_endDate = this.event_startDate;
    },
    async deleteThisDay() {
      this.exclusionDays.push(this.calendarClickedDate);
      await this.acceptAddNewEventsPrompt();
      this.addNewEventPrompt = false;
      //console.log("Exclusion days now", this.exclusionDays);
    },
    confirmDelete() {
      this.addNewEventPrompt = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Delete ${this.typeString}?`,
        accept: this.deleteEvent,
      });
    },
    async deleteEvent() {
      console.log("Deleting event");
      this.$vs.loading();
      await this.$store.dispatch("activationPlan/deleteEvent", {
        eventId: this.event_id,
        venueId: this.activeVenue.venueId,
      });

      this.$vs.loading.close();
      this.$vs.notify({
        color: "danger",
        title: "Deleted " + this.typeString,
        text: `The ${this.typeString} was deleted`,
      });
    },
    show(dates, isSocial, callback) {
      this.callback = callback;
      this.event_type = isSocial ? 1 : 2;
      this.addNewEventPrompt = true;

      // reset form
      this.data = "";
      this.calendarClickedDate = null;
      this.exclusionDays = [];
      this.event_rrule = null;
      this.smc_platform = "Facebook";
      this.smc_type = 0;
      this.smc_cost = 0;
      this.selectedRecurringDays = [];
      this.event_id = "";
      this.event_title = "";
      this.event_description = "";

      this.isRecurring = false;
      this.event_responsible_name = "";
      this.event_responsible_userId = "";
      this.event_tags = [];

      if (dates) {
        this.event_startDate = moment(dates.start).format(this.momentFormat);
        this.event_endDate = moment(dates.end)
          .subtract(1, "days")
          .format(this.momentFormat);
      } else {
        this.event_startDate = null;
        this.event_endDate = null;
      }
    },
    showWith(data, ccd, callback) {
      this.callback = callback;
      this.calendarClickedDate = moment.utc(ccd).toDate();
      this.event_id = data.activationPlanEventId;
      this.event_title = data.title;
      this.event_type = data.type;
      this.isRecurring = data.isRecurring;
      //this.rExclusionDates = data.rExclusionDatesUtcTicks;
      if (this.isRecurring) {
        const tRuleSet = rrulestr(data.rRule, { forceset: true });
        const tRule = tRuleSet.rrules()[0]; // important: assumes only one rule per set
        this.selectedRecurringDays = tRule.options.byweekday;
        this.exclusionDays = tRuleSet.exdates();
      }
      //this.selectedRecurringDays = data.rWeekDays;
      this.event_description = data.description;
      this.event_startDate = moment(data.startDateUtcTicks).format(
        this.momentFormat
      );
      this.event_endDate = moment(data.endDateUtcTicks).format(
        this.momentFormat
      );
      this.event_tags = data.tags;
      this.event_responsible_name = data.meta
        ? data.meta["responsibleName"]
        : "";
      this.event_responsible_userId = data.meta
        ? data.meta["responsibleUserId"]
        : "";

      this.smc_platform = data.meta["platform"];
      this.smc_type = parseInt(data.meta["type"]);
      if (data.type === 2) {
        this.smc_cost = parseInt(data.meta["price"]);
      }
      this.addNewEventPrompt = true;
    },
    remove(item) {
      this.event_tags.splice(this.event_tags.indexOf(item), 1);
    },
    async acceptAddNewEventsPrompt() {
      const event = {
        title: this.event_title,
        description: this.event_description,
        category: "",
        type: this.event_type, // 0 for activity, 1 for SMC, 2 for Paid Media
        startDate: moment(this.event_startDate, this.momentFormat).format(), // valueOf for unix
        endDate: moment(this.event_endDate, this.momentFormat).format(),
        userId: this.userId,
        isRecurring: this.isRecurring,
        venueId: this.activeVenue.venueId,
        tags: this.event_tags,
        ticketLink: "",
        meta: {
          platform: `${this.smc_platform}`,
          price: `${this.smc_cost}`,
          type: `${this.smc_type}`,
          currency: this.currencyCode,
          responsibleName: this.event_responsible_name,
          responsibleUserId: this.event_responsible_userId,
        },
      };

      if (this.isRecurring) {
        const rrule = new RRule({
          ...this.rruleConfig,
          byweekday: this.selectedRecurringDays,
          dtstart: moment.utc(this.event_startDate, this.momentFormat).toDate(),
          until: new Date(
            moment.utc(this.event_endDate, this.momentFormat).format()
          ),
        });

        const rruleSet = new RRuleSet();

        // Add a rrule to rruleSet
        rruleSet.rrule(rrule);
        this.exclusionDays.forEach((e) => rruleSet.exdate(e));

        event.rrule = rruleSet.toString();
      }

      let idForCallback;
      this.$vs.loading();
      if (this.event_id !== "") {
        console.log("Updating event", event);
        event.id = this.event_id;
        idForCallback = this.event_id;
        await this.$store.dispatch("activationPlan/updateEvent", event);
      } else {
        console.log("Adding event", event);
        const result = await this.$store.dispatch(
          "activationPlan/addEvent",
          event
        );
        idForCallback = result.activationPlanEventId;
      }
      this.$vs.notify({
        color: "success",
        title: "Event " + (this.isRecurring ? "updated" : "added"),
        text: "Your event was " + (this.isRecurring ? "updated" : "added"),
      });
      this.$vs.loading.close();

      if (this.callback) {
        this.callback(idForCallback);
      }
    },
    closeAddNewEventsPrompt() {
      if (this.callback) {
        this.callback(null);
      }
    },
  },
};
</script>

<style lang="scss" scoped >
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.con-chips--remove-all {
  display: none;
}

.buttons-footer-left {
  position: absolute;
  bottom: 14px;
  z-index: 100;
  animation: fadeIn ease 500ms forwards;
  animation-delay: 500ms;
  opacity: 0;
}
.con-vs-dialog .vs-dialog {
  max-width: 600px !important;
  position: relative;
}
.vs-select--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6) !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.typeahead-container input {
  padding: 0.7rem !important;
  font-size: 1rem !important;
  color: inherit;
  position: relative;
  padding: 0.4rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  width: 100%;
}

.instructor-chip {
  font-size: 14px;
}
.horizontal-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
</style>
